export const DnD_TYPES = {
    source: "source",
    playlist: "playlist",
    inset: "inset",
    destination: "destination",
    folder: "folder",
};
